import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { THLBoardState } from './hl-board.models';

export const getHLBoardState = (state: TPlani8State) => state.hlBoardInfo;

export const getHLBoardList = createSelector(getHLBoardState, (state: THLBoardState) => state.hlBoardList);
export const getOTLCapacitiesInfo = createSelector(getHLBoardState, (state: THLBoardState) => state.OTLCapacitiesInfo);
export const getWeeklyOPLCapacitiesInfo = createSelector(
  getHLBoardState,
  (state: THLBoardState) => state.WeeklyOPLCapacitiesInfo,
);
export const getDailyOPLCapacitiesInfo = createSelector(
  getHLBoardState,
  (state: THLBoardState) => state.DailyOTLCapacitiesInfo,
);
